import React, { useState, useEffect, useRef } from 'react';
import { LabelField } from './Cost_center.style';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Toast } from 'primereact/toast';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import '../../DataTableDemo.css';
import ConfBar from '../ConfBar/ConfBar';
import Video from '../Video/Video';
import SkeletonTable from '../SkeletonTable/SkeletonTable';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { excelExport } from '../../services/excelExport.service';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Cost_center
Description : Pagina de Cost_center para el CRUD de los centros de costos del aplicativo remunerlite.
Date Autor Modification
================================================================================
15/10/2021 Cristian Andres Pizo Mina - Pagina de Cargo
5/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */
export default function Cost_center() {

  //#region Constantes
  const toast = useRef(null);
  const [name, setName] = useState("");
  const [code, setCode] = useState("");
  const [expenseType, setExpenseType] = useState("");
  const [updateExpenseType, setUpdateExpenseType] = useState("");
  const [listaExpenseType, setListaExpenseType] = useState([]);
  const setOptions_edit = []
  const [detailId, setDetailId] = useState("");
  const [updateName, setUpdateName] = useState("");
  const [updateCode, setUpdateCode] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpen_, setIsOpen_] = React.useState(false);
  const [isOpenEliminar, setIsOpenEliminar] = React.useState(false);
  const [rowData, setRowData] = useState([]);
  const [rowDataExport, setRowDataExport] = useState([]);
  const headers = { authorization: localStorage.getItem('token') }
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');
  const elementWidth = { width: "20rem" }
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [loadPage, setLoadPage] = useState(false)
  const [loading2, setLoading2] = useState(false);

  // Inicializacion de select de tipo de gasto
  useEffect(() => {
    const getLists = async () => {
      await apis.getCenCosList(headers).then(res => {
        let numeric_attribute = res.data["LOV_NUMERIC_ATTRIBUTE"]
        let contenidoNumeric_attribute = []

        numeric_attribute.forEach(element => {
          contenidoNumeric_attribute.push({ "value": '' + element.detail_id + '', "label": '' + element.description + '' });
        })
        setListaExpenseType(contenidoNumeric_attribute);

      })
      setTabla()
    }
    getLists()
  }, []);

  // mostrar modal crear centro de costos
  const showModal = () => {
    setIsOpen(true);
  };

  // cerrar modal crear centro de costos y limpiar campos
  const hideModal = () => {
    limpiar();
    setIsOpen(false);
  };

  // mostrar modal editar centro de costos
  const showModal_ = () => {
    setIsOpen_(true);
  };

  // cerrar modal editar centro de costos
  const hideModal_ = () => {
    setIsOpen_(false)
  };

  // mostrar modal eliminar centro de costos
  const showModalEliminar = (DETAIL_ID) => {
    setDeleteId(DETAIL_ID);
    setIsOpenEliminar(true);
  };

  // cerrar modal eliminar centro de costos
  const hideModalEliminar = () => {
    setIsOpenEliminar(false)
  };

  // inizializar los campos al editar el centro de costos
  function inizilaizarData(rowData) {
    setOptions_edit.push({ "value": '' + rowData.COND_CTB_CODE + '', "label": '' + rowData.COND_CTB + '' });
    setUpdateName(rowData.NAME)
    setUpdateCode(rowData.CODE)
    setUpdateExpenseType(setOptions_edit[0])
    setDetailId(rowData.DETAIL_ID)
    showModal_();
  }

  // limpiar campos
  async function limpiar() {
    setExpenseType("");
    setName("");
    setCode("");
  }

  // validar campos
  function validar() {
    if (expenseType.value == undefined) {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Selecionar tipo de gasto', life: 4000 });
      return false
    } if (name == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar Nombre del centro de costos', life: 4000 });
      return false
    } if (code == "") {
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: 'Agregar código del centro de costos', life: 4000 });
      return false
    }
    return true
  }

  // Inizializar tabla
  async function setTabla() {
    await apis.getCenCos(localStorage.getItem('entity'), localStorage.getItem('client'), "NULL", headers).then(res => {
      if (res.data["CENCOS"].length > 0) {
        console.log(res)
        let data = res.data["CENCOS"]
        let contenidoTabla = []
        let contenidoTablaExport = []
        data.forEach(element => {
          let cond_ctb = element["COND_CTB"].split("|")
          contenidoTabla.push({ DETAIL_ID: element.DETAIL_ID, CODE: element.CODE, NAME: element.NAME, COND_CTB_CODE: cond_ctb[0], COND_CTB: cond_ctb[1] })
          let _element = {
            'Id Centro de costos': element.DETAIL_ID,
            'Nombre': element.NAME,
            'Código': element.CODE,
            'Tipo de gasto': cond_ctb[1]
          }
          contenidoTablaExport.push(_element)
        })
        setRowDataExport(contenidoTablaExport)
        setRowData(contenidoTabla)
        setLoadPage(true)
      } else {
        setRowDataExport([])
        setRowData([])
        setLoadPage(true)
      }
    }).catch(err => {
      console.log(err)
      setLoadPage(true)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })
  }

  // crear centro de costos
  async function completarRegistro() {

    if (validar()) {
      setLoadingCreate(true)

      const _expenseType = expenseType.value;
      const _name = name;
      const _code = code;
      const _cliente = localStorage.getItem('client')
      const _entity = localStorage.getItem('entity')

      const cencos = {
        CLIENT: _cliente,
        ENTITY: _entity,
        NAME: _name,
        CODE: _code,
        COND_CTB: _expenseType
      }

      await apis.postCenCos(cencos, headers).then(res => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Centro de costos agregado exitosamente', life: 4000 });
        hideModal();
        setTabla();
        limpiar();
      }).catch(err => {
        setLoadingCreate(false)
        toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
      })
    }
  }

  // editar centro de costos
  async function actualizar() {
    setLoadingUpdate(true)
    const _detailId = detailId;
    const _expenseType = updateExpenseType.value;
    const _name = updateName;
    const _code = updateCode;
    const _client = localStorage.getItem('client')
    const _entity = localStorage.getItem('entity')

    const cencos = {
      CLIENT: _client,
      ENTITY: _entity,
      NAME: _name,
      CODE: _code,
      COND_CTB: _expenseType,
      DETAIL_ID: _detailId
    }
    console.log(cencos)

    await apis.putCenCos(cencos, headers).then(res => {
      setLoadingUpdate(false)
      setIsOpen_(false);
      setTabla();
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Registro actualizado exitosamente', life: 4000 });

    }).catch(err => {
      setLoadingUpdate(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })



  }

  // eliminar centro de costos
  async function eliminar() {
    setLoadingDelete(true)
    const _cliente = localStorage.getItem('client');
    const _entity = localStorage.getItem('entity')
    const _detailId = deleteId;
    await apis.deleteCenCos(_entity, _cliente, _detailId, headers).then(res => {
      setLoadingDelete(false)
      setIsOpenEliminar(false)
      toast.current.show({ severity: 'info', summary: 'Éxito', detail: 'Centro de costo eliminado', life: 4000 });
    }).catch(err => {
      setLoadingDelete(false)
      toast.current.show({ severity: 'warn', summary: 'Alerta', detail: err.response.data.message.split("\""), sticky: true });
    })

    setTabla();
  }

  const exportExcel = () => {
    excelExport(rowDataExport, 'Centro_costos');
    setLoading2(false);
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm" onClick={showModal} />
      </React.Fragment>
    )
  }

  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button type="button" disabled={rowData.length === 0} icon="pi pi-file-excel" label="Exportar" loading={loading2} onClick={() => { setLoading2(true); exportExcel() }} className="p-button-success mr-2" data-pr-tooltip="XLS" />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return (
      <div className="flex">
        <Button icon="pi pi-pencil" className="p-button-warning  p-button-sm text-xs mr-2" tooltip="Editar centro de costo" tooltipOptions={{ position: 'top' }} onClick={() => { inizilaizarData(rowData) }} />
        <Button icon="pi pi-trash" className="p-button-danger  p-button-sm text-xs" tooltip="Eliminar centro de costo" tooltipOptions={{ position: 'top' }} onClick={() => { showModalEliminar(rowData.DETAIL_ID) }} />
      </div>
    )
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm" onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'DETAIL_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CODE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'COND_CTB': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  // pie de pagina modal crear centro de costos
  const addFooter = (
    <div>
      <Button onClick={hideModal}>Cancelar</Button>
      <Button onClick={completarRegistro} label='Guardar' loading={loadingCreate}></Button>
    </div>
  );

  // encabezado modal crear centro de costos
  const addHeader = (
    <div>
      <h3>Agregar Centro de Costos</h3>
    </div>
  );

  // pie de pagina modal editar centro de costos
  const updateFooter = (
    <div>
      <Button onClick={hideModal_}>Cancelar</Button>
      <Button onClick={actualizar} label='Guardar' loading={loadingUpdate}></Button>
    </div>
  );

  // encabezado modal editar centro de costos
  const updateHeader = (
    <div>
      <h3>Actualizar  Centro de Costos</h3>
    </div>
  );

  // pie de pagina modal eliminar centro de costos
  const deleteFooter = (
    <div>
      <Button onClick={hideModalEliminar}>Cancelar</Button>
      <Button onClick={eliminar} label='Si' loading={loadingDelete}></Button>
    </div>
  );

  // encabezado modal eliminar centro de costos
  const deleteHeader = (
    <div>
      <h3>¿Desea eliminar el  Centro de Costo?</h3>
    </div>
  );

  // Return que entrega la pantalla
  return (

    <div className=''>
      <Toast ref={toast} />
      <div className="flex flex-row align-items-center justify-content-center mb-3 font-bold text-4xl mt-6">
        <span className="text-900">Centro de costos</span>
        <Video header="Instructivo centro de costos" url={localStorage.getItem("ACCOUNTANTACCOUNT_PLAN_VIDEO")} />
      </div>
      <ConfBar />
      <div className="surface-100	 px-4 py-2 md:px-6 lg:px-8">

        <Dialog header={addHeader} footer={addFooter} visible={isOpen} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal}>
          <LabelField htmlFor="label">Tipo de gasto</LabelField>
          <Dropdown style={elementWidth} value={expenseType.value} options={listaExpenseType} placeholder={"Seleccione tipo de gasto"} onChange={setExpenseType} />
          <LabelField htmlFor="label">Nombre centro de costos</LabelField>
          <InputText style={{ width: "20rem" }} value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre centro de costos" />
          <LabelField htmlFor="label">Código para el centro de costos</LabelField>
          <InputText style={{ width: "20rem" }} value={code} onChange={(e) => setCode(e.target.value)} placeholder="Código para el centro de costos" />
        </Dialog>

        <Dialog header={updateHeader} footer={updateFooter} visible={isOpen_} position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModal_} >

          <LabelField htmlFor="label">Tipo de gasto</LabelField>
          <Dropdown style={elementWidth} value={updateExpenseType.value} options={listaExpenseType} onChange={setUpdateExpenseType} placeholder={updateExpenseType.label} />
          <LabelField htmlFor="label">Nombre centro de costos</LabelField>
          <InputText style={{ width: "20rem" }} value={updateName} onChange={(e) => setUpdateName(e.target.value)} placeholder="Nombre centro de costos" />
          <LabelField htmlFor="label">Código para el centro de costos</LabelField>
          <InputText style={{ width: "20rem" }} value={updateCode} onChange={(e) => setUpdateCode(e.target.value)} placeholder="Código para el centro de costos" />
        </Dialog>

        <Dialog header={deleteHeader} footer={deleteFooter} visible={isOpenEliminar}
          position="top" style={{ width: "26rem" }} draggable={false} resizable={false} modal onHide={hideModalEliminar}>
        </Dialog>

        <div className="card mt-4">
          <SkeletonTable load={loadPage}>
            <Toolbar className="mb-4" start={leftToolbarTemplate} end={rightToolbarTemplate} />
            <DataTable className="text-xs" value={rowData} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
              scrollHeight="flex" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="DETAIL_ID"
              size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['DETAIL_ID', 'CODE', 'NAME', 'COND_CTB']}
              header={header1} >
              <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
              <Column field="DETAIL_ID" header="ID Centro de costos" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
              <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
              <Column field="CODE" header="Código" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
              <Column field="COND_CTB" header="Tipo de gasto" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre de usuario" sortable></Column>
              <Column header="Acciones" headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
            </DataTable>
          </SkeletonTable>
        </div>
      </div>
    </div>
  );
}